import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
const {
  Title
} = Typography;
export const SidebarPointTabPanel = ({
  title,
  backText,
  children,
  extra,
  onBack
}: PropsWithChildren & {
  title: string;
  backText: string;
  extra?: React.ReactNode;
  onBack?: () => void;
}) => {
  const {
    t
  } = useTranslation("terms");
  return <div className="pb-4 @container/panel" data-sentry-component="SidebarPointTabPanel" data-sentry-source-file="SidebarPointTabPanel.tsx">
      <div className="sticky top-0 z-10 mb-2 border-b border-gray-200 bg-gray-50 px-2 py-2">
        <div className="block items-center justify-between gap-4 @md/panel:flex">
          {onBack && <Button icon={<ArrowLeftOutlined />} onClick={onBack} type="text" size="small" className="mb-2 h-[24px] shrink-0 whitespace-nowrap px-0 text-gray-800 @md/panel:mb-0">
              {backText}
            </Button>}
          <Title className="min-w-0 tracking-[-0.01em] @md/panel:!mb-0" level={3} data-sentry-element="Title" data-sentry-source-file="SidebarPointTabPanel.tsx">
            <span className="flex min-w-0 items-baseline gap-1 text-sm leading-tight">
              <span className="shrink-0 font-normal text-gray-400">{t("userSuppliedId")}:</span>
              <span title={title} className="line-clamp-1 min-w-0 break-all font-semibold text-gray-900">
                {title}
              </span>
            </span>
          </Title>
        </div>

        {extra && <div className="mt-2 block justify-end @md/panel:flex">
            <div className="w-full @xl/panel:!w-[422px]">{extra}</div>
          </div>}
      </div>
      <div className="flex flex-col gap-12 px-2">{children}</div>
    </div>;
};